// extracted by mini-css-extract-plugin
export var currencyInput = "_ho-1";
export var currencySymbol = "_ho-0";